import PropTypes from 'prop-types'
// import { useRef } from 'react'

function BannerAd({ AdUnitId }) {
  // const adRef = useRef()

  // bitmedia ===============================
  // useEffect(() => {
  //   if (!AdUnitId || !adRef.current) return

  //   // Avoid adding the script again if already exists
  //   if (document.querySelector(`script[data-bm-ad="${AdUnitId}"]`)) return

  //   // Create script tag
  //   const script = document.createElement('script')
  //   script.setAttribute('data-bm-ad', AdUnitId)
  //   script.async = true
  //   script.src = `https://cdn.bmcdn6.com/js/${AdUnitId}.js?v=${Date.now()}`
  //   script.onerror = () => {
  //     script.remove()
  //     // Optionally retry or report error
  //   }

  //   // Append to body (or head)
  //   document.body.appendChild(script)

  //   return () => {
  //     script.remove() // clean up script if ad ID changes or unmounts
  //     if (window.bmblocks && window.bmblocks[AdUnitId]) {
  //       delete window.bmblocks[AdUnitId]
  //     }
  //   }
  // }, [AdUnitId])

  return (
    <div className='BannerAd'>
      {/* bitmedia ====================  */}
      {/* <div className='BannerAd'>
      <ins
        ref={adRef}
        className={AdUnitId}
        style={{
          display: 'inline-block',
          width: '100%',
          height: 'auto',
          maxWidth: '728px',
          margin: '0 auto',
        }}
      ></ins>
    </div> */}

      <div
        id='frame'
        style={{
          width: '100%',
          margin: 'auto',
          position: 'relative',
          height: '100px',
          // background: 'rgba(0, 0, 0, 0.50)',
          // zIndex: 9999,
        }}
      >
        <iframe
          data-aa={AdUnitId}
          src={`//acceptable.a-ads.com/${AdUnitId}/?size=Adaptive`}
          style={{
            border: '0',
            padding: '0',
            width: '100%',
            height: '100px',
            overflow: 'hidden',
            display: 'block',
            margin: 'auto',
          }}
          title='Ad Frame'
        />
      </div>
    </div>
  )
}

BannerAd.propTypes = {
  AdUnitId: PropTypes.string.isRequired,
}

export default BannerAd
